// React
import React from 'react';

// Components
import Wrapper from '../../listing/Wrapper/Wrapper';

// Contexts
import { ListingContext } from '../../../contexts/listing';

// Hooks
import useListing from '../../../hooks/useListing';

// Taxonomies
import {
  salesVersionCore,
  salesVersionListing
} from '../../../taxonomies/salesVersion';

// This component
export default function SalesVersion() {
  // Taxonomies
  const { endpoint } = salesVersionCore();
  const {
    initialSort,
    initialFilters,
    getColumns,
    getRows,
    getFilters
  } = salesVersionListing();

  // Listing
  const {
    page,
    setPage,
    pageSize,
    setPageSize,
    activeFilters,
    saveActiveFilters,
    sortModel,
    setSortModel,
    resetSortModel,
    refreshDataGrid,
    setRefreshDataGrid
  } = useListing(initialSort, initialFilters, endpoint);

  // JSX
  return (
    <ListingContext.Provider
      value={{
        typeOfData: 'taxonomy',
        // Static
        initialFilters,
        endpoint,
        getColumns,
        getRows,
        getFilters,
        // Dynamic
        page,
        setPage,
        pageSize,
        setPageSize,
        activeFilters,
        saveActiveFilters,
        // page: null,
        // setPage: (page) => {},
        sortModel,
        setSortModel,
        resetSortModel,
        refreshDataGrid,
        setRefreshDataGrid
      }}>
      <Wrapper
        title="Sales Versions"
        buttonNewLabel="New Sales Version"
        buttonNewUrl="/sales-version/new"
        exportAction={false}
      />
    </ListingContext.Provider>
  );
}
